module.exports = __webpack_public_path__ + "img/res04.1579951f.png";